import { Box, Grid, Theme } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import React, { useEffect } from 'react';
import { StageState } from '../../../types/type';
import { mapProgressTrackerStep } from './ProgressTrackerMiniUtil';

function getStages(state: StageState, theme: Theme, index: number, uniqueKey: string) {
  const stepperStyles = {
    width: '100%',
    '--line-border-fill': theme.custom.styles.progressStepperComplete,
    '--line-border-empty': theme.custom.styles.progressStepperBackground,
    '--circle-skipped': theme.custom.styles.progressStepperSkipped,

    zIndex: 2,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',

    ':after': {
      content: '',
      'border-bottom': `10px solid ${theme.custom.colors.primaryButtonHoverColor}`,
      width: '100%',
      left: '50%',
      'z-index': 1,
      'margin-top': '-4px',
    },
  };
  const stage = (
    <>
      <div key={uniqueKey} style={{ ...stepperStyles, position: 'relative', marginBottom: '6px' }}>
        <div
          style={{
            position: 'relative',
            zIndex: 2,
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            width: '16px',
            height: '16px',
            borderRadius: '50%',
            background: theme.custom.colors.footerTopBorderColor,
            backgroundColor: theme.custom.colors.footerTopBorderColor,
          }}
        >
          <div
            style={{
              backgroundColor: theme.palette.primary.main,
              position: 'relative',
              zIndex: 1,
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              width: '14px',
              height: '14px',
              borderRadius: '50%',
            }}
          >
            {/* If NOT completed but active, DONT show checkmark */}
            {!state.completed && state.viewActive && (
              <div
                style={{
                  backgroundColor: theme.palette.primary.main,
                  position: 'relative',
                  zIndex: 1,
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center',
                  width: '14px',
                  height: '14px',
                  borderRadius: '50%',
                }}
              ></div>
            )}
            {/* If NOT completed, NOT active, NOT skipped, show gray circle */}
            {!state.completed && !state.viewActive && !state.skipped && (
              <div
                style={{
                  backgroundColor: theme.custom.styles.progressStepperBackground,
                  position: 'relative',
                  zIndex: 1,
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center',
                  width: '14px',
                  height: '14px',
                  borderRadius: '50%',
                }}
              ></div>
            )}
          </div>
        </div>
      </div>
      {index !== 3 && (
        <div
          style={{
            content: '',
            borderBottom: `2px solid ${theme.custom.colors.primaryButtonHoverColor}`,
            width: '100%',
            left: '50%',
            zIndex: 1,
            marginBottom: '12px',
          }}
        ></div>
      )}
    </>
  );
  return stage;
}

const ProgressTrackerMini = (props: { step: any; marginLeft: string; name: string }) => {
  let progress: null | HTMLElement;
  let circles: any[] | NodeListOf<Element>;
  const theme: Theme = useTheme();
  useEffect(() => {
    circles = document.querySelectorAll('div.circle');
    progress = document.getElementById('progress');
  }, []);
  const trackerSteps: StageState[] = mapProgressTrackerStep(props.step);
  return (
    <Box
      title="progressBar"
      sx={{
        width: '33%',
        marginLeft: props.marginLeft,
      }}
    >
      <Grid>
        <div
          style={{
            marginTop: 'auto',
            display: 'flex',
            justifyContent: 'space-between',
          }}
        >
          {props.step &&
            trackerSteps.map((state, index) => (
              <React.Fragment key={index}>{getStages(state, theme, index, props.name)}</React.Fragment>
            ))}
        </div>
      </Grid>
    </Box>
  );
};

export default ProgressTrackerMini;
